type AddressType = {
  id: number;
  title: string;
  lat: number;
  lang: number;
  address: string;
  mobile: string;
  is_default: number;
};

type WalletType = {
  id: number;
  current_inventory: number;
  type: number;
  main_status: number;
};

type UserRollType = {
  uid: number | null | string;
  id: number | null | string;
  type: number | null | string;
  supplier_id: number | string | null;
  title: string;
  params: number | string | null;
  value: number | null | string;
  status: number | string;
};
type AccessLevel = {
  full: {}[];
  codes: Array<string | number>;
  isSuperAdmin: boolean;
  supplierList: { id: string | number; title: string }[];
};

type SupplierType = {
  id: string;
  main_cat: string;
  title: string;
  description: string;
  cover_file_id: string;
  logo_file_id: string;
  address: string;
  tell1: string;
  tell2: string;
  email: string;
  mobile: string;
  site: string;
  instagram: string;
  main_admin_uid: string;
  mtm: string;
  muid: string;
  uptm: string;
  upuid: string;
  main_status: string;
  bank_info: string;
  start_hour: string;
  finish_hour: string;
  start_min: string;
  finish_min: string;
  avg_rate: string;
  count_rate: string;
  min_order_amount: string;
  complate_order_count: string;
  active_order_count: string;
  canceled_order_count: string;
  total_saled_amount: string;
  shipping_cost: string;
  lat: string;
  lang: string;
  is_send_out_range: string;
  send_in_cost: string;
  send_out_cost: string;
  send_in_time: string;
  send_out_time: string;
  adminIdCartFileId: string;
  businessLiecenseFileId: string;
};

interface UserType {
  id: number;
  firstname: string;
  lastname: string;
  token: string;
  adminpanelkey?: string;
  mobile: string;
  supplier?: SupplierType;
  addresses: AddressType[];
  wallet: WalletType;
  user_rolls: UserRollType[];
  access_level: AccessLevel;
}

enum AuthActionType {
  LogIn,
  LogOut,
  ChangeInfo,
  GetAddresses,
}

type ActionType =
  | {
      type: AuthActionType.LogIn;
      payload: UserType;
    }
  | {
      type: AuthActionType.ChangeInfo;
      payload: { firstname?: string; lastname?: string; mobile?: string };
    }
  | {
      type: AuthActionType.GetAddresses;
      payload: AddressType[];
    }
  | {
      type: AuthActionType.LogOut;
    };

const authReducer: React.Reducer<UserType, ActionType> = (
  state,
  action
): UserType => {
  switch (action.type) {
    case AuthActionType.LogIn:
      return action.payload;
    case AuthActionType.ChangeInfo:
      return { ...state, ...action.payload };
    case AuthActionType.GetAddresses:
      return { ...state, addresses: [...action.payload] };
    case AuthActionType.LogOut:
      return {
        id: 0,
        firstname: "",
        lastname: "",
        token: "",
        addresses: [],
        mobile: "",
        user_rolls: [],
        wallet: {
          id: 0,
          current_inventory: 0,
          main_status: 0,
          type: 0,
        },
        access_level: {
          full: [],
          codes: [],
          isSuperAdmin: false,
          supplierList: [],
        },
      };
    default:
      return state;
  }
};

export default authReducer;

export type { UserType, AddressType, UserRollType, AccessLevel };

export { AuthActionType };
